<template>
  <div id="app">
    <NavBar />
    <div class="content-container">
      <router-view/>
    </div>
    <InActiveNotification />
  </div>
</template>

<script>
import InActiveNotification from 'shared_ui_components/src/auth/InActiveNotification'
import NavBar from '@/components/NavBar'

export default {
  components: {NavBar, InActiveNotification},
  name: 'app'
}
</script>

<style>
  html, body {
    margin: 0;
    padding: 0;
    font-family: 'Nunito Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 1.15em;
  }

  html, body, #app {
    height: 100%;
  }

  @font-face {
    font-family: 'opificio';
    src:  url('./assets/fonts/opificio_regular-webfont.woff2') format('woff2'),
    url('./assets/fonts/opificio_regular-webfont.woff') format('woff');
  }
</style>

<style scoped>
  .content-container {
    height: calc(100% - 60px);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue